import { useState } from "react";
import "./nav.css";

import Logo from "../assets/logo.svg";

export function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="container nav-content">
        <div className="logo">
          <img src={Logo} alt="Logo" className="logo-img-nav" />
          <h1 className="logo-txt-nav">La Estrella <span className="green">PODA EN ALTURA</span></h1>
        </div>
        <button className="menu-btn" onClick={() => setOpen(!open)}>
          ☰
        </button>

        <nav className={`nav-links ${open ? "active" : ""}`} onClick={() => setOpen(false)}>
          <a href="#services">Servicios</a>
          <a href="#about">Nosotros</a>
          <a href="#gallery">Trabajos</a>
          <a href="#contact">
            Contacto
          </a>
        </nav>
      </div>
    </header>
  );
}